import styled from 'styled-components';

export const ContentWrap = styled.div`
    margin-top: ${props => props.marginBottom};
    padding-bottom: ${props => props.paddingBottom};
    ul {
        margin-bottom: 0;
    }
    li {
        font-size: ${props => props.theme.fontSize.primary};
        font-family: ${props => props.theme.fontFamily.helveticaNeue};
        color: ${props => props.theme.fontColors.textColor};
        @media only screen and (min-width: 320px) and (max-width: 767px) {
            font-size: ${props => props.theme.fontSize.secondary};
            font-family: ${props => props.theme.fontFamily.helveticaNeue};
        }
    }
`

export const Content = styled.li`
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: 1.71;
    color: ${props => props.theme.fontColors.textColor};
    
`